import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicProductAuthorizeRequest {
  @jsonMember(String)
  public readonly password: string;

  public constructor(password: string) {
    this.password = password;
  }
}
